"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const initialState = {
    current: undefined,
};
function campaignExportReducer(state = initialState, action) {
    switch (action.type) {
        case 'CREATE_CAMPAIGN_EXPORT_SUCCESS':
            return Object.assign(Object.assign({}, state), { current: action.campaignExport });
        case 'FETCH_CAMPAIGN_EXPORT_SUCCESS':
            return Object.assign(Object.assign({}, state), { current: action.campaignExport });
        case 'FETCH_CAMPAIGN_EXPORT_FAILURE':
            const current = state.current;
            if (current) {
                return Object.assign(Object.assign({}, state), { current: Object.assign(Object.assign({}, current), { error: action.message, done: true }) });
            }
        default:
    }
    return state;
}
exports.default = campaignExportReducer;
